<div class="add-container">
    <h1 class="add-title">Adaugă o modificare</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">

        <div>

            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data aprobarii prelungirii/modificarii Acord/Autorizatie</mat-label>
                    <input matInput [matDatepicker]="picker_data_prelungire_modificare" formControlName="document_data"
                        readonly (focus)="picker_data_prelungire_modificare.open()" />
                    <mat-error *ngIf="
                          !form.controls['document_data'].valid &&
                          form.controls['document_data'].touched
                        ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix
                        [for]="picker_data_prelungire_modificare"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_prelungire_modificare></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Număr cerere</mat-label>
                    <input type="number" matInput formControlName="cerere_numar" />
                    <mat-error *ngIf="
                          !form.controls['cerere_numar'].valid &&
                          form.controls['cerere_numar'].touched
                        ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Data Cerere</mat-label>
                    <input matInput [matDatepicker]="picker_data_cerere" formControlName="cerere_data" readonly
                        (focus)="picker_data_cerere.open()" />
                    <mat-error *ngIf="
                          !form.controls['cerere_data'].valid &&
                          form.controls['cerere_data'].touched
                        ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_cerere"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_cerere></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Valabilitate</mat-label>
                    <input matInput [matDatepicker]="picker_data_valabilitate" formControlName="valability" readonly
                        (focus)="picker_data_valabilitate.open()" />
                    <mat-error *ngIf="
                        !form.controls['valability'].valid &&
                        form.controls['valability'].touched
                    ">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker_data_valabilitate"></mat-datepicker-toggle>
                    <mat-datepicker #picker_data_valabilitate></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Orar de funcționare</mat-label>
                    <textarea type="text" matInput formControlName="orar_functionare"></textarea>
                    <mat-error *ngIf="
                        !form.controls['orar_functionare'].valid && form.controls['orar_functionare'].touched
                    ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="add-field">
                <mat-form-field appearance="fill">
                    <mat-label>Observații</mat-label>
                    <textarea type="text" matInput formControlName="observatii"></textarea>
                    <mat-error *ngIf="
                        !form.controls['observatii'].valid && form.controls['observatii'].touched
                    ">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>